<template>
    <div class="container">
                

                <div v-show="sendActive">


                    <div class="pt-3">
                        
                        <b-form-group label-cols-sm="2" label-align-sm="right" label="Send this deck to:">
                          <b-button variant="primary" @click="showHideSingleBulk('single')" value="single">A Single Recipient</b-button>
                          <b-button variant="primary" @click="showHideSingleBulk('campaign')" value="campaign">A Mailing List</b-button> 
                          or 
                          <b-button variant="primary" @click="goToShowLink()">Share a link</b-button>
                        </b-form-group>
                       

                       

                    </div>


                </div>



                <div v-show="showLink">
                  <div>
                    
                      <b-form-group label="Link" description="This is the link to your sizzledeck, you can share this link via email, social media or however you like. To mark this sizzledeck as 'sent' and enable tracking, click the all done button below.">
                        <b-input type="text" v-model="link"></b-input>
                      </b-form-group>

                      <div><b-button variant="secondary" @click="goToSelectSend()">Back</b-button><b-button variant="primary" class="float-right" @click="shareLink()">All Done</b-button></div>
                    
                  </div>
                </div>



                <div v-show="singleSendActive">
                    <div>
                      
							            <input type="hidden" name="id" :value="deckid"></input>
                          <input type="hidden" name="_token" :value="csrf"></input>


                            <div v-show="singleStepOneActive">

                                  <b-tabs content-class="mt-3">
                                    <b-tab class="pb-3" title="Choose Existing Contact" active>
                                      <bootstrap-table-deck-send-contacts @selectContact="onSelectContact"></bootstrap-table-deck-send-contacts>
                                    </b-tab>
                                    <b-tab title="Add a New Contact">

                                      <b-form-group label-cols-sm="2" label="First Name:" label-align-sm="right" label-for="first-name"><b-form-input  id="first-name" name="first-name" v-model="firstName"></b-form-input></b-form-group>
                                      <b-form-group label-cols-sm="2" label="Last Name:" label-align-sm="right" label-for="last-name"><b-form-input id="last-name" name="last-name" v-model="lastName"></b-form-input></b-form-group>
                                      <b-form-group label-cols-sm="2" label="Company Name:" label-align-sm="right" label-for="company-name"><b-form-input id="company-name" name="company-name" v-model="companyName"></b-form-input></b-form-group>
                                      <b-form-group label-cols-sm="2" label="Email Address:" label-align-sm="right" label-for="email"><b-form-input v-model="email" type="email" id="email" name="email" :required="emailAddressActive"></b-form-input></b-form-group>
                                      <b-form-group label-cols-sm="2" label="Mobile Number:" label-align-sm="right" label-for="phone"><vue-tel-input v-model="phone" :required="mobileNumberActive" placeholder="" mode="international"></vue-tel-input></b-form-group>      

                                      <b-button variant="primary" class="float-right" @click="checkSingleStepOne()">Add Contact</b-button>


                                    </b-tab>
                                    <b-tab class="pb-3" title="Select Capsule Contact">
                                        <bootstrap-table-deck-send-capsule-contacts></bootstrap-table-deck-send-capsule-contacts>
                                    </b-tab>
                                  </b-tabs>

    
                                <div><b-button variant="secondary" @click="goToSelectSend()">Back</b-button></div>

                            </div>

                            <div v-show="singleStepTwoActive">


                              <b-form-group label-cols-sm="2" label-align-sm="right" label="Send this deck via:">
                                  <b-button variant="primary" v-bind:class="{ active: sendVia === 'both' }">Email and SMS</b-button>
                                  <b-button variant="primary" v-bind:class="{ active: sendVia === 'email' }">Email Only</b-button>
                                  <b-button variant="primary" v-bind:class="{ active: sendVia === 'sms' }">SMS Only</b-button>
                              </b-form-group>


                      

                                <div><b-button variant="secondary" @click="goToSingleStepOne()">Back</b-button><b-button variant="primary" class="float-right" @click="saveContactDetails()">Next</b-button></div>

                            </div>

                            <div v-show="singleStepThreeActive">

          						          <b-form-group label="SMS Message" :description="'This is the accompanying text message your recipient will see when they receive your SizzleDeck on their mobile phone. This message will use : '+ Math.ceil(sms_message.length / 120) +' SMS Credit(s)'">
                                  <b-input type="text" v-model="sms_message"></b-input>
                                </b-form-group>


                                <div>

                                  <b-button variant="secondary" @click="goToSingleStepTwo()">Back</b-button>
                                  <b-button v-show="sendVia === 'both'" variant="primary" class="float-right" @click="goToSingleStepFour()">Next</b-button>
                                  <b-button v-show="sendVia === 'sms'" variant="primary" class="float-right" @click="goToSingleStepFive()">Next</b-button>
                                </div>

                            </div>

                            <div v-show="singleStepFourActive">

          						          <b-form-group label="Email Subject">
                                  <b-input type="text" v-model="email_subject"></b-input>
                                </b-form-group>

          						          <b-form-group label="Email Message">
                                  <b-form-textarea type="text" v-model="email_body"></b-form-textarea>
                                </b-form-group>

          						          <b-form-group label="Button Text">
                                  <b-input type="text" v-model="email_button"></b-input>
                                </b-form-group>

          						          <b-form-group label="Email Footer">
                                  <b-form-textarea type="text" v-model="email_footer"></b-form-textarea>
                                </b-form-group>

                                <div>
                                  <b-button v-show="sendVia === 'both'" variant="secondary" @click="goToSingleStepThree()">Back</b-button>
                                  <b-button v-show="sendVia === 'email'" variant="secondary" @click="goToSingleStepTwo()">Back</b-button>


                                  <b-button variant="primary" class="float-right"  @click="goToSingleStepFive()">Next</b-button>
                                </div>

                            </div>

                            <div v-show="singleStepFiveActive">

                            	<div class="text-center">
                                <b-button variant="secondary" :href="preview_deck_url" target="_blank">Preview Deck</b-button> 
                                <b-button variant="secondary" v-show="sendVia === 'both' || sendVia === 'sms'" @click="previewSMS()">Preview SMS</b-button> 
                                <b-button variant="secondary" v-show="sendVia === 'both' || sendVia === 'email'" @click="previewEmail()">Preview Email</b-button>
                              </div>
                            	
                            	<div class="text-center">
                                <b-button variant="primary" class="float-right" @click="scheduleSingleSend()">Send Deck</b-button>
                              </div>

                            	<div>
                                <b-button variant="secondary" v-show="sendVia !== 'sms'" @click="goToSingleStepFour()">Back</b-button>
                                <b-button variant="secondary" v-show="sendVia === 'sms'" @click="goToSingleStepThree()">Back</b-button>
                              </div>

                            </div>

                        

                      
                    </div>
                </div>


                <div v-show="bulkSendActive">



                    <div>
                      
                        

                        <div v-show="bulkStepOneActive">
                          <b-form-group label="Select Mailinglist(s) you wish to send to:">
                            <b-form-checkbox
                              v-for="mailinglist in mailinglists"
                              v-model="selectedMailinglists"
                              :key="mailinglist.id"
                              :value="mailinglist.id"
                              name="mailinglists[]">
                              {{ mailinglist.name }} ({{ mailinglist.size_minus_suppressed }})
                            </b-form-checkbox>
                          </b-form-group>

                          <b-button variant="secondary" @click="goToSelectSend()">Back</b-button>
                          <b-button variant="primary" class="float-right"  @click="goToBulkStepTwo()">Next</b-button>

                        </div>

                        <div v-show="bulkStepTwoActive">

                            <b-form-group label-cols-sm="2" label-align-sm="right" label="Send this deck via:">
                              <b-button variant="primary" v-bind:class="{ active: sendVia === 'both' }" @click="showHideFields('both')">Email and SMS</b-button>
                              <b-button variant="primary" v-bind:class="{ active: sendVia === 'email' }" @click="showHideFields('email')">Email Only</b-button>
                              <b-button variant="primary" v-bind:class="{ active: sendVia === 'sms' }" @click="showHideFields('sms')">SMS Only</b-button>
                            </b-form-group>

                          <b-button variant="secondary" @click="goToBulkStepOne()">Back</b-button>
                          
                          
                          <b-button v-show="sendVia === 'both'" variant="primary" class="float-right" @click="goToBulkStepThree()">Next</b-button>
                          <b-button v-show="sendVia === 'email'" variant="primary" class="float-right" @click="goToBulkStepFour()">Next</b-button>
                          <b-button v-show="sendVia === 'sms'" variant="primary" class="float-right" @click="goToBulkStepThree()">Next</b-button>

                        </div>

                        <div v-show="bulkStepThreeActive">

                            <b-form-group label="SMS Message" :description="'This is the accompanying text message your recipient will see when they receive your SizzleDeck on their mobile phone. This message will use : '+ Math.ceil(sms_message.length / 120) +' SMS Credit(s)'">
                              <b-input type="text" v-model="sms_message"></b-input>
                            </b-form-group>


                            <div>

                              <b-button variant="secondary" @click="goToBulkStepTwo()">Back</b-button>
                              <b-button v-show="sendVia === 'both'" variant="primary" class="float-right" @click="goToBulkStepFour()">Next</b-button>
                              <b-button v-show="sendVia === 'sms'" variant="primary" class="float-right" @click="goToBulkStepFive()">Next</b-button>
                            </div>

                        </div>

                        <div v-show="bulkStepFourActive">

                            <b-form-group label="Email Subject">
                              <b-input type="text" v-model="email_subject"></b-input>
                            </b-form-group>

                            <b-form-group label="Email Message">
                              <b-form-textarea type="text" v-model="email_body"></b-form-textarea>
                            </b-form-group>

                            <b-form-group label="Button Text">
                              <b-input type="text" v-model="email_button"></b-input>
                            </b-form-group>

                            <b-form-group label="Email Footer">
                              <b-form-textarea type="text" v-model="email_footer"></b-form-textarea>
                            </b-form-group>

                            <div>
                              <b-button v-show="sendVia === 'both'" variant="secondary" @click="goToBulkStepThree()">Back</b-button>
                              <b-button v-show="sendVia === 'email'" variant="secondary" @click="goToBulkStepTwo()">Back</b-button>


                              <b-button variant="primary" class="float-right"  @click="goToBulkStepFive()">Next</b-button>
                            </div>

                        </div>

                        <div v-show="bulkStepFiveActive">

                          <div class="text-center">
                            <b-button variant="secondary" :href="preview_deck_url" target="_blank">Preview Deck</b-button> 
                            <b-button variant="secondary" v-show="sendVia === 'both' || sendVia === 'sms'" @click="previewSMS()">Preview SMS</b-button> 
                            <b-button variant="secondary" v-show="sendVia === 'both' || sendVia === 'email'" @click="previewEmail()">Preview Email</b-button>
                          </div>
                          
                          <div class="text-center">
                            <b-button variant="primary" class="float-right" @click="scheduleBulkSend()">Send Deck</b-button>
                          </div>

                          <div>
                            <b-button variant="secondary" v-show="sendVia !== 'sms'" @click="goToBulkStepFour()">Back</b-button>
                            <b-button variant="secondary" v-show="sendVia === 'sms'" @click="goToBulkStepThree()">Back</b-button>
                          </div>

                        </div>
                        

                      
                    </div>





                </div>
              

      			    <b-modal id="sms-modal" size="lg" hide-footer title="SMS Preview">
      			      <div class="d-block" v-html="sms_preview_message">
      			        
      			      </div>
      			    </b-modal>
                <b-modal id="email-modal" size="lg" hide-footer :title="'Email Preview - Subject: '+email_subject">
                  <div class="d-block" v-html="email_preview_message">
                    
                  </div>
                </b-modal>


                
    </div>
</template>

<script>

import axios from 'axios';
import Noty from 'noty';

    export default {
        mounted() {

            var vm = this;
            axios.post('/deck/get',{id: vm.deckid}).then(response => {

              this.sms_message = response.data.sms_message;
              this.email_subject = response.data.email_subject;
              this.email_body = response.data.email_body;
              this.email_button = response.data.email_button;
              this.email_footer = response.data.email_footer;

	            axios.get('/deck/defaults/').then(response => {

	              if(vm.sms_message == null){ vm.sms_message = 'Hi [firstname], great chatting earlier. Here is some more info about SizzleDeck as discussed:'; }
	              if(vm.email_subject == null){ vm.email_subject = 'More Info for [firstname]'; }
	              if(vm.email_body == null){ vm.email_body = 'Hi [firstname], \r\rGreat chatting. Here is some more info about SizzleDeck as discussed.'; }
	              if(vm.email_button == null){ vm.email_button = 'Click to View'; }
	              if(vm.email_footer == null){ 
	              	 vm.email_footer = 'Any questions, just let me know.\r\rKind regards,\r\r'+response.data.first_name+' '+response.data.last_name+'\r';
	              	 if(response.data.position){vm.email_footer = vm.email_footer+'\r'+response.data.position;}
	              	 vm.email_footer = vm.email_footer+'\r'+response.data.company_name; 
	              }

	            }).catch(() => console.warn('Oh. Something went wrong. getDeckDefaults'));

            }).catch(() => console.warn('Oh. Something went wrong.'));




        },
        props: [
            'deckid'
        ],
        data: function(){
            return {                
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                sendActive: true,
                sendType: '',
                sendVia: '',

                singleSendActive: false,
                
                emailAddressActive: false,
                mobileNumberActive: false,
                singleStepOneActive: true,
                singleStepTwoActive: false,
                singleStepThreeActive: false,
                singleStepFourActive: false,
                singleStepFiveActive: false,


                
                bulkSendActive: false,
                bulkStepOneActive: true,
                bulkStepTwoActive: false,
                bulkStepThreeActive: false,
                bulkStepFourActive: false,
                bulkStepFiveActive: false,



                phone: null,
                email: null,
                firstName: null,
                lastName: null,
                companyName: null,
                contact_id: null,

                mailinglists:[],
                selectedMailinglists:[],

                sms_message: '',

                email_subject: null,
                email_body: 'Hi [firstname],\rGreat chatting. Here is some more info about SizzleDeck as discussed.',
                email_button: 'Click to View',
                email_footer: 'Any questions, just let me know.',

                preview_deck_url: '/deck/preview/'+this.deckid,
                sms_preview_message: null,
                email_preview_message: null,

                showLink: false,
                link: null

                

            };
        },
        methods:{      

            goToSelectSend: function(){
            	this.singleSendActive = false;
            	this.bulkSendActive = false;
              this.showLink = false;
                this.sendType = '';
                this.$nextTick(function () {
  					     this.sendActive = true;
				        });
            },
            goToShowLink: function(){

              var vm = this;

              axios.post('/deck/getlink',{id: vm.deckid}).then(response => {

                vm.sendActive = false;
                vm.showLink = true;
                vm.link = response.data;

              }).catch(() => console.warn('Oh. Something went wrong.'));
                
            },
            shareLink: function(){
              
              var vm = this;

              axios.post('/deck/marksent',{id: vm.deckid}).then(response => {

               window.location.href = '/deck/results';

              }).catch(() => console.warn('Oh. Something went wrong.'));

            },
            goToBulkStepOne: function(){
              // Select ML
              this.bulkStepOneActive = true;
              this.bulkStepTwoActive = false;
              this.bulkStepThreeActive = false;
              this.bulkStepFourActive = false;
              this.bulkStepFiveActive = false;

            },
            goToBulkStepTwo: function(){

            	var vm = this;

            	if(vm.selectedMailinglists.length == 0){
    	        	new Noty({
                      text: 'Please select one or more mailinglists to continue.',
                      type: 'error',
                      theme: 'bootstrap-v4',
                      layout: 'topCenter',
                      timeout: 2000
                    }).show();
    	        	return;
    	    	}
                          

              axios.post('/deck/sync-mailinglists',{
                id: vm.deckid,
                mailinglists: vm.selectedMailinglists,
              }).then(response => {
              
                  // Select Send Via
                  this.bulkStepOneActive = false;
                  this.bulkStepTwoActive = true;
                  this.bulkStepThreeActive = false;
                  this.bulkStepFourActive = false;
                  this.bulkStepFiveActive = false;

                   }).catch( error => {

                        if(error.response.status == '419'){

                          new Noty({
                                  text: 'You have been logged out due to inactivity. Please refresh this page to login.',
                                  type: 'error',
                                  theme: 'bootstrap-v4',
                                  layout: 'topCenter',
                                  timeout: 2000
                              }).show();

                        }else{

                        new Noty({
                                  text: 'There has been an error, please try again.',
                                  type: 'error',
                                  theme: 'bootstrap-v4',
                                  layout: 'topCenter',
                                  timeout: 2000
                              }).show();
                      }
              });


            },
            goToBulkStepThree: function(){
              // Compose SMS
              this.bulkStepOneActive = false;
              this.bulkStepTwoActive = false;
              this.bulkStepThreeActive = true;
              this.bulkStepFourActive = false;
              this.bulkStepFiveActive = false;
            },
            goToBulkStepFour: function(){
              // Compose Email
              this.bulkStepOneActive = false;
              this.bulkStepTwoActive = false;
              this.bulkStepThreeActive = false;
              this.bulkStepFourActive = true;
              this.bulkStepFiveActive = false;
            },
            goToBulkStepFive: function(){

              var vm = this;

              axios.post('/deck/store',{
                id: vm.deckid,
                sms_message: vm.sms_message,
                  email_subject: vm.email_subject,
                  email_body: vm.email_body,
                  email_button: vm.email_button,
                  email_footer: vm.email_footer
              }).then(response => {
              
                if(response.data.status == 'success'){

                  // Preview & Bulk Send
                  this.bulkStepOneActive = false;
                  this.bulkStepTwoActive = false;
                  this.bulkStepThreeActive = false;
                  this.bulkStepFourActive = false;
                  this.bulkStepFiveActive = true;

                }else{

                    new Noty({
                        text: response.data.message,
                        type: 'error',
                        theme: 'bootstrap-v4',
                        layout: 'topCenter',
                        timeout: 2000
                    }).show();

                }

                   }).catch( error => {

                        if(error.response.status == '419'){

                          new Noty({
                                  text: 'You have been logged out due to inactivity. Please refresh this page to login.',
                                  type: 'error',
                                  theme: 'bootstrap-v4',
                                  layout: 'topCenter',
                                  timeout: 2000
                              }).show();

                        }else{

                        new Noty({
                                  text: 'There has been an error, please try again.',
                                  type: 'error',
                                  theme: 'bootstrap-v4',
                                  layout: 'topCenter',
                                  timeout: 2000
                              }).show();
                      }
              });

            },
            goToSingleStepOne: function(){
                this.singleStepOneActive = true;
                this.singleStepTwoActive = false;
                this.singleStepThreeActive = false;
                this.singleStepFourActive = false;
                this.singleStepFiveActive = false;
            },

            checkSingleStepOne: function(){

        		switch(this.sendVia){
        			case 'email':
        				this.checkEmail();
        			break;
        			case 'sms':
        				this.checkTelephone();
        			break;
        			case 'both':
        				this.checkEmailAndTelephone();
        			break;
        		}

            },
            onSelectContact: function(){
              console.log('meeeeeep');
            },
        	goToSingleStepTwo: function(){

        		this.singleStepOneActive = false;
            this.singleStepTwoActive = true;
            this.singleStepThreeActive = false;
            this.singleStepFourActive = false;
            this.singleStepFiveActive = false;
        		

        	},
          goToSingleStepThree: function(){
            this.singleStepOneActive = false;
            this.singleStepTwoActive = false;
            this.singleStepThreeActive = true;
            this.singleStepFourActive = false;
            this.singleStepFiveActive = false;
          },
          saveContactDetails: function(){

            	// Save Contact Details
            	var vm = this;

                axios.post('/contact/save/lookup',{
                	lookup: vm.sendVia,
                	email:vm.email,
                	telephone:vm.phone,
                	first_name:vm.firstName,
                	last_name:vm.lastName,
                	company_name:vm.companyName,
                }).then(response => {
	                    
                      if(response.data.status == 'success'){

                      vm.contact_id = response.data.contact.id;
                      vm.preview_deck_url = '/deck/preview/'+vm.deckid+'/'+response.data.contact.id;

			                vm.singleStepOneActive = false;
			                vm.singleStepTwoActive = false;
			                vm.singleStepThreeActive = true;


                        if(vm.sendVia == 'email'){ 
                          // If Email only then skip sms step
                          vm.goToSingleStepFour(); 
                        }else{ 
                          vm.goToSingleStepThree();
                        } 

                      }else{

                          new Noty({
                              text: response.data.message,
                              type: response.data.status,
                              theme: 'bootstrap-v4',
                              layout: 'topCenter',
                              timeout: 1000
                          }).show();

                      }

	                }).catch( error => {

	                      if(error.response.status == '419'){

	                        new Noty({
	                                text: 'You have been logged out due to inactivity. Please refresh this page to login.',
	                                type: 'error',
	                                theme: 'bootstrap-v4',
	                                layout: 'topCenter',
	                                timeout: 2000
	                            }).show();

	                      }else{

	                      new Noty({
	                                text: 'There has been an error, please try again.',
	                                type: 'error',
	                                theme: 'bootstrap-v4',
	                                layout: 'topCenter',
	                                timeout: 2000
	                            }).show();
	                    }
	             });

            },
            goToSingleStepFour: function(){

                this.singleStepThreeActive = false;
                this.singleStepFourActive = true;
                this.singleStepFiveActive = false;

            },
            goToSingleStepFive: function(){

            	var vm = this;

            	axios.post('/deck/store',{
            		id: vm.deckid,
	            	sms_message: vm.sms_message,
	                email_subject: vm.email_subject,
	                email_body: vm.email_body,
	                email_button: vm.email_button,
	                email_footer: vm.email_footer
            	}).then(response => {

                if(response.data.status == 'success'){

	                this.singleStepOneActive = false;
        					this.singleStepTwoActive = false;
        					this.singleStepThreeActive = false;
        					this.singleStepFourActive = false;
	                this.singleStepFiveActive = true;


                }else{

                    new Noty({
                        text: response.data.message,
                        type: 'error',
                        theme: 'bootstrap-v4',
                        layout: 'topCenter',
                        timeout: 2000
                    }).show();

                }

              }).catch( error => {

	                      if(error.response.status == '419'){

	                        new Noty({
	                                text: 'You have been logged out due to inactivity. Please refresh this page to login.',
	                                type: 'error',
	                                theme: 'bootstrap-v4',
	                                layout: 'topCenter',
	                                timeout: 2000
	                            }).show();

	                      }else{

	                      new Noty({
	                                text: 'There has been an error, please try again.',
	                                type: 'error',
	                                theme: 'bootstrap-v4',
	                                layout: 'topCenter',
	                                timeout: 2000
	                            }).show();
	                    }
	            });

            },
            previewSMS: function(){

              var vm = this;

              axios.post('/deck/sms-preview',{deck_id:vm.deckid,send_type:vm.sendType,contact_id:vm.contact_id}).then(response => {

                this.sms_preview_message = response.data.sms_message;

                this.$bvModal.show('sms-modal');

              }).catch(() => console.warn('Oh. Something went wrong.'));

            },
            previewEmail: function(){

              var vm = this;

              axios.post('/deck/email-preview',{deck_id:vm.deckid,send_type:vm.sendType,contact_id:vm.contact_id}).then(response => {

                this.email_preview_message = response.data.email_message;

                this.$bvModal.show('email-modal');

              }).catch(() => console.warn('Oh. Something went wrong.'));

            },

            showHideSingleBulk: function(value){
                var vm = this;
              	this.sendActive = false;
              	this.sendType = value;
                
                switch(value){
                    case 'single':
                        this.singleSendActive = true;
                        this.bulkSendActive = false;
                    break;
                    case 'campaign':
                        this.singleSendActive = false;
                        this.bulkSendActive = true;

                        axios.get('/contacts/mailinglist/list').then(response => {

                          	vm.mailinglists = response.data.rows;

                          	// Remove Empty Lists
	                        vm.mailinglists = vm.mailinglists.filter(function( mailinglist ) {
							    return mailinglist.size !== 0;
							});


                          this.bulkStepOneActive = true;

                        }).catch(() => console.warn('Oh. Something went wrong. showHideSingleBulk(campaign)'));

                    break;
                }
            },
            checkEmail: function(advanceStep=true){

            	var vm = this;

                axios.post('/contact/lookup/email',{email:vm.email}).then(response => {
	                    
                      if(response.data.status == 'success'){
                      	
                      	if(response.data.contact == '' || response.data.contact == null){
                      		if(advanceStep){
                      			// New Contact - Empty inputs and continue
                      			vm.firstName = vm.lastName = vm.companyName = null;
              	            	vm.goToSingleStepTwo();
							}
                      	}else{

                      			// Existing Contact found - auto populate
                      			new Noty({
	                                text: 'Contact Found. Auto filling Data',
	                                type: 'success',
	                                theme: 'bootstrap-v4',
	                                layout: 'topCenter',
	                                timeout: 2000
	                            }).show();

                      			vm.phone = response.data.contact.telephone;
                      			vm.firstName = response.data.contact.first_name;
                      			vm.lastName = response.data.contact.last_name;
                      			vm.companyName = response.data.contact.company_name;

  								if(advanceStep){
  									vm.goToSingleStepTwo();
  								}

                      	}	                
                      
                      }else{

                          new Noty({
                              text: response.data.message,
                              type: response.data.status,
                              theme: 'bootstrap-v4',
                              layout: 'topCenter',
                              timeout: 1000
                          }).show();

                      }

	                }).catch( error => {

	                      if(error.response.status == '419'){

	                        new Noty({
	                                text: 'You have been logged out due to inactivity. Please refresh this page to login.',
	                                type: 'error',
	                                theme: 'bootstrap-v4',
	                                layout: 'topCenter',
	                                timeout: 2000
	                            }).show();

	                      }else{

	                      new Noty({
	                                text: 'There has been an error, please try again.',
	                                type: 'error',
	                                theme: 'bootstrap-v4',
	                                layout: 'topCenter',
	                                timeout: 2000
	                            }).show();
	                    }
	             });
            },
            checkTelephone: function(advanceStep=true){

            	var vm = this;

                axios.post('/contact/lookup/telephone',{telephone:vm.phone}).then(response => {
	                    
                      if(response.data.status == 'success'){

                      	if(response.data.contact == '' || response.data.contact == null){

                  			  if(advanceStep){
                  				  // New Contact - Empty inputs and continue
                      			vm.firstName = vm.lastName = vm.companyName = null;
            								vm.goToSingleStepTwo();
            							}

                      	}else{
 
                      			// Existing Contact found - auto populate
                      			new Noty({
	                                text: 'Contact Found. Auto filling Data',
	                                type: 'success',
	                                theme: 'bootstrap-v4',
	                                layout: 'topCenter',
	                                timeout: 2000
	                            }).show();

                      			vm.email = response.data.contact.email;
                      			vm.firstName = response.data.contact.first_name;
                      			vm.lastName = response.data.contact.last_name;
                      			vm.companyName = response.data.contact.company_name;

                      			if(advanceStep){
            									vm.goToSingleStepTwo();
            								}
                      	}	                
                      
                      }else{

                          new Noty({
                              text: response.data.message,
                              type: response.data.status,
                              theme: 'bootstrap-v4',
                              layout: 'topCenter',
                              timeout: 1000
                          }).show();

                      }

	                }).catch( error => {

	                      if(error.response.status == '419'){

	                        new Noty({
	                                text: 'You have been logged out due to inactivity. Please refresh this page to login.',
	                                type: 'error',
	                                theme: 'bootstrap-v4',
	                                layout: 'topCenter',
	                                timeout: 2000
	                            }).show();

	                      }else{

	                      new Noty({
	                                text: 'There has been an error, please try again.',
	                                type: 'error',
	                                theme: 'bootstrap-v4',
	                                layout: 'topCenter',
	                                timeout: 2000
	                            }).show();
	                    }
	             });
            },
            checkEmailAndTelephone: function(){
            	var vm = this;

                axios.post('/contact/lookup/both',{email:vm.email,telephone:vm.phone}).then(response => {
	                    
                      if(response.data.status == 'success'){
                      	
                      	if(response.data.count == 0){
                      		// New Contact - Empty inputs and continue
                      		vm.firstName = vm.lastName = vm.companyName = null;
                      		vm.goToSingleStepTwo();
                      	}else if(response.data.count == 1){

                      			  if(vm.email !== response.data.contact.email && response.data.contact.email !== null){

	                      		      var notyDialog = new Noty({
									  text: 'Existing contact found but with a different email. Shall I update the contact with the email you have entered or replace with it the one we have on file?',
									  type: 'warning',
									  theme: 'bootstrap-v4',
		                              layout: 'topCenter',
									  buttons: [
									    Noty.button('Use Exiting Email on File', 'btn btn-secondary mt-1 center', function () {

									        vm.email = response.data.contact.email;
			                				notyDialog.close();

									    }),

									    Noty.button('Update Contact with New Email', 'btn btn-secondary mt-1 center', function () {


                                          axios.post('/contact/save/id',{
                                            id: response.data.contact.id,
                                            email:vm.email,
                                          }).then(response => {
                                                
                                                if(response.data.status == 'success'){

                                                  notyDialog.close();

                                                }else{

                                                    new Noty({
                                                        text: response.data.message,
                                                        type: response.data.status,
                                                        theme: 'bootstrap-v4',
                                                        layout: 'topCenter',
                                                        timeout: 1000
                                                    }).show();

                                                }

                                            }).catch( error => {

                                                  if(error.response.status == '419'){

                                                    new Noty({
                                                            text: 'You have been logged out due to inactivity. Please refresh this page to login.',
                                                            type: 'error',
                                                            theme: 'bootstrap-v4',
                                                            layout: 'topCenter',
                                                            timeout: 2000
                                                        }).show();

                                                  }else{

                                                  new Noty({
                                                            text: 'There has been an error, please try again.',
                                                            type: 'error',
                                                            theme: 'bootstrap-v4',
                                                            layout: 'topCenter',
                                                            timeout: 2000
                                                        }).show();
                                                }
                                         });
  
                                        


									    })
									  ]
									}).show();

                      			  }
                      			  else if(vm.phone !== response.data.contact.telephone && response.data.contact.telephone !== null){

	                      		      var notyDialog = new Noty({
              									  text: 'Existing contact found but with a different number. Shall I update the contact with the number you have entered or replace with it the one we have on file?',
              									  type: 'warning',
              									  theme: 'bootstrap-v4',
              		                              layout: 'topCenter',
              									  buttons: [
              									    Noty.button('Use Exiting Number on File', 'btn btn-secondary mt-1 center', function () {

                                        vm.phone = response.data.contact.telephone;
              			                		notyDialog.close();

              									    }),

              									    Noty.button('Update Contact with New Number', 'btn btn-secondary mt-1 center', function () {



                                          axios.post('/contact/save/id',{
                                            id: response.data.contact.id,
                                            telephone:vm.phone,
                                          }).then(response => {
                                                
                                                if(response.data.status == 'success'){

                                                  notyDialog.close();

                                                }else{

                                                    new Noty({
                                                        text: response.data.message,
                                                        type: response.data.status,
                                                        theme: 'bootstrap-v4',
                                                        layout: 'topCenter',
                                                        timeout: 1000
                                                    }).show();

                                                }

                                            }).catch( error => {

                                                  if(error.response.status == '419'){

                                                    new Noty({
                                                            text: 'You have been logged out due to inactivity. Please refresh this page to login.',
                                                            type: 'error',
                                                            theme: 'bootstrap-v4',
                                                            layout: 'topCenter',
                                                            timeout: 2000
                                                        }).show();

                                                  }else{

                                                  new Noty({
                                                            text: 'There has been an error, please try again.',
                                                            type: 'error',
                                                            theme: 'bootstrap-v4',
                                                            layout: 'topCenter',
                                                            timeout: 2000
                                                        }).show();
                                                }
                                         });
  
                								        

              									    })
              									  ]
              									}).show();

                      			  }else{

                      			  	// Existing Contact found - auto populate
	                      			new Noty({
		                                text: 'Contact Found. Auto filling Data',
		                                type: 'success',
		                                theme: 'bootstrap-v4',
		                                layout: 'topCenter',
		                                timeout: 2000
		                            }).show();
	                      			
	                      			vm.firstName = response.data.contact.first_name;
	                      			vm.lastName = response.data.contact.last_name;
	                      			vm.companyName = response.data.contact.company_name;

									vm.goToSingleStepTwo();

                      			  }

                      	}else{

              			    var notyDialog = new Noty({
							  text: 'The Email and Number entered are for two different contacts.',
							  type: 'warning',
							  theme: 'bootstrap-v4',
                              layout: 'topCenter',
							  buttons: [
							    Noty.button('I wish to send to the contact associated with the Email', 'btn btn-secondary mt-1 center', function () {

							        vm.checkEmail(true);
	                				notyDialog.close();

							    }),

							    Noty.button('I wish to send to the contact associated with the Number', 'btn btn-secondary mt-1 center', function () {

							    	vm.checkTelephone(true);
							        notyDialog.close();
							    })
							  ]
							}).show();

                      	}               
                      
                      }else{

                          new Noty({
                              text: response.data.message,
                              type: response.data.status,
                              theme: 'bootstrap-v4',
                              layout: 'topCenter',
                              timeout: 1000
                          }).show();

                      }

	                }).catch( error => {

	                      if(error.response.status == '419'){

	                        new Noty({
	                                text: 'You have been logged out due to inactivity. Please refresh this page to login.',
	                                type: 'error',
	                                theme: 'bootstrap-v4',
	                                layout: 'topCenter',
	                                timeout: 2000
	                            }).show();

	                      }else{

	                      new Noty({
	                                text: 'There has been an error, please try again.',
	                                type: 'error',
	                                theme: 'bootstrap-v4',
	                                layout: 'topCenter',
	                                timeout: false
	                            }).show();
	                    }
	             });
            },
            scheduleSingleSend: function(){


              var vm = this;

                axios.post('/deck/send',{id:vm.deckid,type:'single',via: vm.sendVia,contact_id: vm.contact_id}).then(response => {

                      if(response.data.status == 'success'){

                          window.location.href = '/deck/results';
                      
                      }else{

                          new Noty({
                              text: response.data.message,
                              type: response.data.status,
                              theme: 'bootstrap-v4',
                              layout: 'topCenter',
                              timeout: false
                          }).show();

                      }

                  }).catch( error => {

                        if(error.response.status == '419'){

                          new Noty({
                                  text: 'You have been logged out due to inactivity. Please refresh this page to login.',
                                  type: 'error',
                                  theme: 'bootstrap-v4',
                                  layout: 'topCenter',
                                  timeout: 2000
                              }).show();

                        }else{

                        new Noty({
                                  text: 'There has been an error, please try again.',
                                  type: 'error',
                                  theme: 'bootstrap-v4',
                                  layout: 'topCenter',
                                  timeout: 2000
                              }).show();
                      }
               });

            },
            scheduleBulkSend: function(){

              var vm = this;

                axios.post('/deck/send',{id:vm.deckid,type:'bulk',via: vm.sendVia,mailinglists: vm.selectedMailinglists}).then(response => {

                      if(response.data.status == 'success'){

                          window.location.href = '/deck/results';
                      
                      }else{

                          new Noty({
                              text: response.data.message,
                              type: response.data.status,
                              theme: 'bootstrap-v4',
                              layout: 'topCenter',
                              timeout: 1000
                          }).show();

                      }

                  }).catch( error => {

                        if(error.response.status == '419'){

                          new Noty({
                                  text: 'You have been logged out due to inactivity. Please refresh this page to login.',
                                  type: 'error',
                                  theme: 'bootstrap-v4',
                                  layout: 'topCenter',
                                  timeout: 2000
                              }).show();

                        }else{

                        new Noty({
                                  text: 'There has been an error, please try again.',
                                  type: 'error',
                                  theme: 'bootstrap-v4',
                                  layout: 'topCenter',
                                  timeout: 2000
                              }).show();
                      }
               });

            }
        }

    }
</script>
